import { useForm } from "@/features/tutor/context/FormContext";
import {
  selectIsNotepadOpen,
  useNotepadStore,
} from "@/features/notepad/store/useNotepadStore";

export const useCaptionsUnavailable = (): boolean => {
  const isCanvasOpen = useNotepadStore(selectIsNotepadOpen);
  const { formData } = useForm();

  return formData.language?.value === "hi" && isCanvasOpen;
};
